module.exports = __webpack_public_path__ + "static/img/IMG_20241028_142353-EFFECTS.cf7d16c2.jpg";